// Cheque scanner: camera OR gallery → sends to /api/cheques/scan → confirm modal
import { useRef, useState, useEffect } from "react";
import { toast } from "sonner";
import { Receipt, Loader2, Images } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { ChequeConfirmModal } from "@/components/add/ChequeConfirmModal";

export function ChequeCapture({ autoStart = false, direction = "outgoing", onDone }) {
  const { t, lang } = useI18n();
  const camRef = useRef(null);
  const galRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [thumb, setThumb] = useState(null);
  const [parsed, setParsed] = useState(null);
  const [suggested, setSuggested] = useState(null);
  useEffect(() => { if (autoStart) setTimeout(() => camRef.current?.click(), 120); }, [autoStart]);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setThumb(URL.createObjectURL(file));
    setBusy(true);
    const fd = new FormData();
    fd.append("image", file);
    try {
      const { data } = await api.post("/cheques/scan", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const p = data?.parsed || {};
      if (!p || (!p.amount && !p.payee)) {
        toast.info(lang === "ar" ? "لم نستطع قراءة الشيك، جرّب مرة أخرى" : "Couldn't read cheque, try again");
      } else {
        setParsed(p);
        setSuggested(data?.suggested_account_id || null);
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("error"));
    } finally { setBusy(false); }
  };

  return (
    <div className="flex flex-col items-center gap-6">
      <input data-testid="cheque-input" ref={camRef} type="file" accept="image/*"
        capture="environment" className="hidden" onChange={onFile} />
      <input data-testid="cheque-gallery-input" ref={galRef} type="file" accept="image/*"
        className="hidden" onChange={onFile} />
      <button data-testid="cheque-shutter" onClick={() => camRef.current?.click()} disabled={busy}
        className="w-40 h-40 rounded-full neu-fill-blue text-white grid place-items-center active:scale-95 transition-all shadow-2xl shadow-blue-900/40 disabled:opacity-70">
        {busy ? <Loader2 className="w-14 h-14 animate-spin" /> : <Receipt className="w-14 h-14" />}
      </button>
      <p className="text-sm text-slate-600 text-center max-w-sm">{busy ? t("scanning") : t("chequeScan")}</p>
      <button data-testid="cheque-gal-btn" onClick={() => galRef.current?.click()} disabled={busy}
        className="h-12 px-6 rounded-2xl neu-btn font-semibold flex items-center justify-center gap-2 neu-accent-blue disabled:opacity-60">
        <Images className="w-4 h-4" />{lang === "ar" ? "اختيار من المعرض" : "Choose from gallery"}
      </button>
      {thumb && <img src={thumb} alt="preview" className="max-h-40 rounded-2xl neu-sm" />}
      <ChequeConfirmModal
        open={!!parsed} parsed={parsed} suggestedAccountId={suggested} direction={direction}
        onClose={() => { setParsed(null); onDone?.(); }}
        onSaved={() => { setParsed(null); onDone?.(); }}
        onScanAgain={() => { setParsed(null); camRef.current?.click(); }}
      />
    </div>
  );
}
